import axios from "axios";
import authHeader from "./AuthHeader";
import AuthService from "../service/AuthService";
// import { createMessage, returnErrors } from "./../actions/messages";
// import { tokenConfig } from "./../actions/auth";
// import { ADD_UserT, DELETE_UserT, GET_UserTS } from "../actions/types";

const apiUrl = process.env.REACT_APP_URL;
const slug = AuthService.getLng();
const slugGet = AuthService.getLng() + "/api/auth/users";
const slugUpdate = AuthService.getLng() + "/api/auth/user/";
const slugCreate = AuthService.getLng() + "/api/auth/newuser";
const getLogUserInfo = AuthService.getLng() + "/api/auth/user";
const slugChangePass = AuthService.getLng() + "/api/auth/changepass";
const publicUrl = process.env.PUBLIC_URL;
const bodyParameters = {};

export class UserService {


  generateEmailRequestUrl(url) {

    if (url == '/') {
      return '/#/';
    } else {
      return url + '/#/';
    }

  }

  generateEmailRequestUrlForGet(url) {

    let genurl = '';
    if (url == '/') {
      genurl = '/#/';
    } else {
      genurl = url + '/#/';
    }

    const params = { public_url: genurl }
    const paramString = new URLSearchParams(params)
    return `${paramString.toString()}`;

  }

  // slanje verifikacionig maila za usera
  requestVerificationEmail() {

    const emailUrl = this.generateEmailRequestUrlForGet(publicUrl);

    return axios.get(apiUrl + slug + "/api/auth/request-verification-email/?" + emailUrl, {
      headers: authHeader(),

    })
      .then((response) => {
        return response;
      });
  }

  // pozivanje akcije za verifikaciju
  emailverify(token) {
    return axios.get(apiUrl + slug + "/api/auth/email-verify?token=" + token, {
      headers: authHeader(),
    }).then((response) => {

      if (true) {

        axios
          .get(apiUrl + getLogUserInfo, {
            headers:
            {
              Authorization: "Bearer " + AuthService.getToken(),
              "Content-Type": "application/json",
              accept: "application/json",
            }
          })
          .then((res) => res.data).then((response) => {
            localStorage.setItem("user", JSON.stringify(response));
          });
      }

      return response;
    });
  }

  // pozivanje akcije za verifikaciju
  passwordReset(id, token) {
    return axios.get(apiUrl + slug + "/api/auth/password-reset/" + id + "/" + token + "/", {
      headers: authHeader(),
    }).then((response) => {


      return response;
    });
  }


  // pozivanje akcije za verifikaciju
  setNewPassword(password, uidb64, token) {
    return axios.patch(apiUrl + slug + "/api/auth/password-reset-complete/", {
      password, uidb64, token,
      headers: authHeader(),
    }).then((response) => {

      return response;
    });
  }



  getUsers() {
    return axios
      .get(apiUrl + slugGet, {
        headers: authHeader(),
      })
      .then((res) => res.data);
  }

  newUser(data) {
    return axios
      .post(apiUrl + slugCreate, {}, {
        headers: authHeader(),
        data,
      })
      .then((res) => res.data);
  }


  updateUser(id, data) {
    return axios
      .put(apiUrl + slugUpdate + `${id}/`, bodyParameters, {
        headers: authHeader(),
        data,
      })
      .then((res) => res.data);
  }

  getLogUser() {
    return axios
      .get(apiUrl + getLogUserInfo, {
        headers: authHeader()
      })
      .then((res) => res.data);
  }

  changePassword(username, password) {
    return axios
      .put(apiUrl + slugChangePass, {
        headers: authHeader(),
        username,
        password,
      })
      .then((res) => res.data);
  }
}
